import React from 'react'
import { useSearchParams } from 'react-router-dom'
export function useUrlSearchParams() {
    const [searchParams, setSearchParams] = useSearchParams()
    //     because of each component calling both this and useNav they are issued anew for each page view
    //     I like having different pages,  diff. urls, a page 3, a page 7.
    //     state strategy - chosen to use useSearchParams as a stand-in for useState.
    //     allows the use of the bookmark to store and send fence estimates easily.
    //     sessionObj created in next line that allows for easy object to read 'state'

    // const idRef = React.useRef('' + (Date.now() % 1000) + `-Srch`)
    // console.log(
    //     `%c ${idRef.current} in context`,
    //     'background: #222; color: red'
    // )

    // IMPORTANT sessionObj does not change when we setSearchParams() in handleInputChange. a rerender of component required to generate new value.
    // we are updating this value wo a useref bec. it is refreshed on ea. render from URL.  It needs to refreshed in handleInputChange before that.
    let sessionObj = React.useMemo(
        () => Object.fromEntries([...searchParams]),
        [searchParams]
    )
    const handleInputChange = React.useCallback(
        ({ target: { value } }, { paramKey }) => {
            // console.log(
            //     `%c handleInputChange and useUrl is ${idRef.current} `,
            //     'background: pink; color: black'
            // )
            const default_err_text =
                paramKey === 'map_posts' && value === '' ? '' : ''

            // console.log(
            //     `${idRef.current} in handleInputChange In useURLSearch useEffect, with parakKey of ${paramKey} with table going IN with...`
            // )
            // console.table(sessionObj)

            // get rid of err setting ea. time.  if needed it wil be applied again.
            if ('err' in sessionObj) {
                // eslint-disable-next-line no-unused-vars
                const { err, ...rest } = sessionObj
                sessionObj = { ...rest }
            }

            //  clean up simple input corruption for the only textField input
            if (paramKey === 'size') value = parseInt(value, 10)

            // if material for fence element is a tree then no brace diagonal necessary
            const braceParamObj = enforceMaterialBraceRules(
                value,
                paramKey,
                sessionObj
            )

            let newObject = {
                ...sessionObj,
                ...braceParamObj,
                [paramKey]: value || default_err_text,
            }

            //validate fence length
            if (paramKey === 'size' || paramKey === 'unit') {
                const size = paramKey === 'size' ? value : sessionObj.size
                const unit = paramKey === 'unit' ? value : sessionObj.unit
                if (!isSizeValid(size, unit)) {
                    newObject = {
                        ...newObject,
                        ['err']: 1,
                    }
                }
            }

            setSearchParams(
                {
                    ...newObject,
                },
                { replace: true }
            )
            // console.log(
            //     `${idRef.current} in handleInputChange In useURLSearch useEffect with table going OUT with...`
            // )
            // refer to explanation above at sessionObj callback
            // eslint-disable-next-line
            sessionObj = newObject
            // console.table(sessionObj)
        },

        [sessionObj, setSearchParams]
    )

    const handleValue = (paramKey = 'error', defaultValue = '') => {
        return searchParams.get(paramKey) || defaultValue
    }

    //         SESSION OBJECT FOLDED

    //               GglMap: [{ unit: 'feet' }, { size: '0' }, {zoom: '4'} { map_posts: '[]' }],

    //               unit: 'feet',// alternative meters
    //               size: '1000',// length of perimeter
    //               strands: '4',
    //               color: '0',// [ 'White', 'Black', 'Checkered'],
    //               spacing: '30',// always in feet - must regard 'unit' (or measure) before displaying
    //               p_mats: '0',// wp (Wood/Pipe), tr (Tree), tp (T-Post)
    //               corners: '4',
    //               c_mats: '0',  // ['Wood/Pipe', 'Tree'],
    //               c_hbrace: '0', // [ 'Braid', 'Wood', 'None'],
    //               g_mats: '0',
    //               g_hbrace:  '0', //[ 'Braid', 'Wood', 'None'],
    //               ends: '0',
    //               e_mats: '0',
    //               e_hbrace:  '0', //[ 'Braid', 'Wood', 'None'],
    //               gates: '1',  // YES OR NO
    //               kit: '0',  // YES OR NO
    //               i_color: '0',  //  ['Black', 'White'],

    //    }
    const setDefault = React.useCallback(
        (pgID) => {
            const defValue = {
                // MAINTAIN - ONLY ONE PARAM PER OBJECT
                GglMap: [
                    { unit: 'feet' },
                    { size: '0' },
                    { zoom: '4' },
                    { map_posts: '[]' },
                    { center: '{}' },
                ], //   will be added
                2: [{ unit: 'feet' }, { size: '1000' }],
                3: [{ strands: '4' }, { color: '0' }],
                4: [{ spacing: '30' }, { p_mats: '0' }],
                5: [{ corners: '4' }, { c_mats: '0' }, { c_hbrace: '0' }],
                6: [{ gates: '1' }, { g_mats: '0' }, { g_hbrace: '0' }],
                7: [{ ends: '0' }, { e_mats: '0' }, { e_hbrace: '0' }],
                8: [{ kit: '0' }, { i_color: '0' }],
                9: [],
                // GglAddr: [
                //     { unit: 'feet' },
                //     { addr: '' },
                // ],
            }

            //we on this page, if there are no values in state then load this obj w. some defaults
            const defaultValues = defValue[pgID].reduce((acc, paramObject) => {
                const defaultKey = Object.keys(paramObject)
                if (defaultKey.length > 1) {
                    throw new Error(
                        'useUrlSearchParams using more than on param in defValue object'
                    )
                }
                const [key] = defaultKey
                return key in sessionObj
                    ? acc
                    : { ...acc, [key]: paramObject[key] }
            }, {})

            //  if there are values in def object, incl in state
            if (Object.keys(defaultValues).length) {
                const newObject = {
                    ...sessionObj,
                    ...defaultValues,
                }
                setSearchParams(
                    {
                        ...newObject,
                    },
                    { replace: true }
                )
                // console.log(
                //     `${idRef.current} in setDefault In useURLSearch useEffect with table going OUT with...`
                // )
                // refer to explanation above at sessionObj callback
                // eslint-disable-next-line
                sessionObj = newObject
                // console.table(sessionObj)
            }
        },
        [setSearchParams, sessionObj]
    )
    React.useEffect(() => {
        // console.log(`${idRef.current} in useEffect`)
    })

    return [handleInputChange, handleValue, sessionObj, setDefault]
}

function enforceMaterialBraceRules(value, paramKey, sessionObj) {
    if (paramKey.includes('_mats')) {
        let braceParamKey = paramKey.slice(0, 1) + '_hbrace'

        // a tree
        if (value === '1') {
            return { [braceParamKey]: '2' } // must be 'None'
        }
        // if Wood/Pipe then can't be 'None'. Default to Braid.
        if (value === '0' && sessionObj[braceParamKey] === '2') {
            return { [braceParamKey]: '0' }
        }
    }
    return {}
}
// TODO: 05/19/24 have a acre to permiter function for user
function isSizeValid(size, unit) {
    const limit = unit === 'meters' ? 75000 : 240000

    const sizeInt = parseInt(size, 10)
    if (Number.isNaN(sizeInt)) {
        return false
    }
    return sizeInt < limit && sizeInt > 0 ? sizeInt : 0
}
